import React from 'react';
import { Breadcrumbs, Link, Typography } from '@mui/material';

const breadcrumbBaseSx = {
  fontFamily: 'Poppins',
  fontWeight: 500,
  fontSize: '11px',
  lineHeight: '1.5',
  letterSpacing: '0.15px',
  color: '#8695AF',
} as const;

const SchedulesBreadcrumbs = React.memo(function SchedulesBreadcrumbs() {
  return (
    <Breadcrumbs
      aria-label='breadcrumb'
      separator={<Typography sx={breadcrumbBaseSx}>/</Typography>}
      sx={{
        width: '100%',
        margin: 0,
        '& .MuiBreadcrumbs-ol': {
          alignItems: 'center',
        },
        '& .MuiBreadcrumbs-separator': {
          marginX: '8px',
          marginY: 0,
        },
      }}
    >
      <Typography sx={breadcrumbBaseSx}>Home</Typography>
      <Link
        underline='none'
        href='/'
        sx={{ ...breadcrumbBaseSx, cursor: 'pointer' }}
      >
        ...
      </Link>
      <Typography sx={{ ...breadcrumbBaseSx, color: '#00A5FF' }}>
        Escalas
      </Typography>
    </Breadcrumbs>
  );
});

export default SchedulesBreadcrumbs;
